import { Col, Container, Image, Row } from 'react-bootstrap';
import AbstractImage from 'assets/img/landing/abstractSwirl.png';
import Arrow from 'assets/img/landing/arrow.svg';

const storyData = [
  { label: 'Enterprise', value: '10k' },
  { label: 'College', value: '10+' },
  { label: 'Countries', value: '100+' }
];

function Story() {
  return (
    <Container className="pb-14 px-lg-14 bg-body-highlight" fluid>
      <Row>
        <Col
          lg={6}
          className="d-flex flex-column align-items-center justify-content-center pe-lg-1 position-relative"
        >
          <div className="w-100 border text-center py-1 rounded-4 mb-1 d-flex align-items-center justify-content-center gap-3">
            <p className="fs-4 fw-semibold m-0">
              Our <span className="text-secondary-light">Story</span>
            </p>
            <Image src={Arrow} alt="arrow" width={35} />
          </div>
          <Image src={AbstractImage} alt="abstractImg" width="100%" />
          <div className="position-absolute bottom-0 p-lg-9 p-6">
            <div className="d-flex align-items-end gap-5">
              <p className="fs-4 fw-bold text-white mb-1">From</p>
              <p className="fs-10 text-white">
                Our Journey is Fueled By Innovation, Empowering Individuals And
                Organizations To Achieve Their True Potential
              </p>
            </div>
            <p className="fs-4 fw-bold text-white m-0">Vision to Impact:</p>
            <p className="fs-4 fw-bold text-white">Our Journey of Innovation</p>
          </div>
        </Col>
        <Col lg={6} className="ps-lg-1">
          <div className="bg-gray-200 rounded-5 p-5 w-100 h-100 d-flex flex-column justify-content-end">
            <p className="fs-9">
              CRUD Beat started with a vision to address the challenges faced by
              educational institutions and organizations in preparing students
              for the job market. Founded by a team of innovators passionate
              about education and technology, we realized the need for a
              platform that not only assesses candidates but also equips them
              with the real-world skills they need to succeed.
            </p>
            <p className="fs-9 mb-10">
              From our humble beginnings to becoming a trusted name in hiring
              and training, our journey has been defined by innovation,
              collaboration, and a commitment to empowering talent everywhere.
            </p>
            <Row>
              {storyData.map((value, index) => (
                <Col lg={4} key={`story-${index}`} className="p-0">
                  <div className="m-1 bg-gray-100 p-3 rounded-4">
                    <p className="m-0 fs-9 text-body-quaternary">
                      {value.label}
                    </p>
                    <p className="m-0 text-end fs-6 fw-semibold">
                      {value.value}
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Story;
